import { Button, Flex, Select } from "@radix-ui/themes";
import { Pagination as HeadlessPagination } from "react-headless-pagination";
import { twMerge } from "tailwind-merge";

export type PaginationProps = {
  currentPage: number;
  setCurrentPage: (page: number) => void;
  totalPages: number;
  pageSize?: number;
  setPageSize?: (pageSize: number) => void;
};

export function Pagination({
  currentPage,
  setCurrentPage,
  totalPages,
  pageSize,
  setPageSize,
}: PaginationProps) {
  return (
    <Flex gap="4" align="center">
      <Select.Root
        value={String(pageSize)}
        onValueChange={(value) => setPageSize?.(Number(value))}
      >
        <Select.Trigger />
        <Select.Content>
          <Select.Item value="10">10</Select.Item>
          <Select.Item value="20">20</Select.Item>
          <Select.Item value="50">50</Select.Item>
          <Select.Item value="100">100</Select.Item>
          <Select.Item value="250">250</Select.Item>
          <Select.Item value="500">500</Select.Item>
          <Select.Item value="1000">1000</Select.Item>
        </Select.Content>
      </Select.Root>
      <HeadlessPagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
        edgePageCount={2}
        middlePagesSiblingCount={1}
        truncableText="..."
        className="flex items-center gap-2 text-sm select-none"
      >
        <HeadlessPagination.PrevButton
          as={<Button variant="outline" color="gray" />}
          className={twMerge([
            "flex items-center text-gray-500 hover:text-gray-600",
            currentPage === 0 && "opacity-50",
          ])}
        >
          Prev
        </HeadlessPagination.PrevButton>
        <nav className="flex justify-center flex-grow">
          <ul className="flex items-center gap-1">
            <HeadlessPagination.PageButton
              as={<Button variant="outline" color="gray" />}
              activeClassName="!font-semibold bg-neutral-100"
              inactiveClassName="font-normal"
              className={
                "flex font-normal items-center justify-center text-black"
              }
            />
          </ul>
        </nav>
        <HeadlessPagination.NextButton
          as={<Button variant="outline" color="gray" />}
          className={twMerge([
            "flex items-center mr-2 text-gray-500 hover:text-gray-600 dark:hover:text-gray-200",
            currentPage === totalPages - 1 && "opacity-50",
          ])}
        >
          Next
        </HeadlessPagination.NextButton>
      </HeadlessPagination>
    </Flex>
  );
}
